import {
  Avatar,
  Box,
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Stack,
  SvgIcon,
  Container,
  Checkbox,
} from "@mui/material";
import useConfirm from "../../../hooks/useConfirm";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { setUsers } from "../../../features/users/usersSlice";
import { ROLES, User } from "../../../types/types";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { avatars } from "../components/avatars";
import PlusIcon from "@heroicons/react/24/solid/PlusIcon";
import { Scrollbar } from "../components/scrollbar";
import { TableCellIconStyles } from "../../../styles/theme";
import { dbDeleteUser, deleteUser, getAllUsers } from "../../../api/api";
import NotificationService from "../../../components/notification/NotificationService";

export const Users = () => {
  const [Dialog, confirmDelete] = useConfirm(
    "Er du sikker?",
    `Er du sikker på at du vil slette denne bruger? Det er ikke muligt at fortryde dette valg, og der kan ikke oprettes en bruger med samme email igen.`
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const users = useAppSelector((state) => state.users.users);

  useEffect(() => {
    getAllUsers().then((data) => {
      dispatch(setUsers(data));
    });
  }, []);

  const deleteUserHandler = async (uid: string) => {
    const confirmed = await confirmDelete();

    if (confirmed) {
      deleteUser(uid).then(() => {
        dispatch(setUsers([...users].filter((user) => user.id !== uid)));
        NotificationService.showToast({
          severity: 'success',
          text: 'Bruger slettet'
        })
      }).catch((error) => {
        console.error(error)
        NotificationService.showToast({
          severity: 'error',
          text: 'Noget gik galt'
        })
      })
    }
  };

  return (
    <>
      {Dialog()}
      <Container maxWidth="xl">
        <Stack spacing={3}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Typography variant="h4">Brugere</Typography>
            <div>
              <Button
                onClick={() => navigate(ROUTES.SUPER_ADMIN_CREATE_USERS)}
                startIcon={
                  <SvgIcon fontSize="small">
                    <PlusIcon />
                  </SvgIcon>
                }
                variant="contained"
              >
                Opret
              </Button>
            </div>
          </Stack>
          <Card>
            <Scrollbar>
              <Box sx={{ minWidth: 300 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Email</TableCell>
                      <TableCell>Rolle</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {users
                      .filter((u) => u.role !== ROLES.SUPER_ADMIN && u.role !== ROLES.PLAYER)
                      .map((user, i) => {
                        return (
                          <TableRow hover key={user.id}>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>
                              <Stack alignItems="center" direction="row" spacing={2}>
                                <Typography variant="subtitle2">{user.role.toUpperCase()}</Typography>
                              </Stack>
                            </TableCell>
                            <TableCell
                              sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", height: "40px" }}
                            >
                              <DeleteOutlineOutlinedIcon
                                sx={TableCellIconStyles}
                                onClick={() => deleteUserHandler(user.id ?? "")}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </Box>
            </Scrollbar>
          </Card>
        </Stack>
      </Container>
    </>
  );
};
